export default "__VITE_ASSET__BWO8bual__"